






































import { Vue, Component, Prop, PropSync, Ref } from 'vue-property-decorator'
import arrayCrdtSortNumber from 'src/assets/arrayCrdtSortNumber'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import FileInput from 'components/presenter/item/FileInput.vue'
import FileFolder from 'components/presenter/item/FileFolder.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    FileInput
  }
})
export default class ItemTopicInfoEditorFileForm extends Vue {

  @Prop()
  readonly item!: Item

  @Prop()
  readonly files!: Json[]

  @PropSync('fileSync')
  file!: Json

  @Ref()
  readonly dialog!: DialogFullscreen

  @Ref()
  readonly folder!: FileFolder

  show () {
    this.dialog.show()
  }

  hide () {
    this.dialog.hide()
    this.$emit('hide')
  }

  async updateUrl (url: string) {
    if (this.file.id) {
      const infoSettings: Json = {}
      infoSettings[`files:${this.file.id}:url`] = url
      await this.item.data?.save({ infoSettings })
    } else {
      this.file.url = url
      if (url.startsWith('/')) {
        this.file.name = url.replace(/(\/\d+)+\/.{36}\./g, '')
      }
      await this.create()
    }
  }

  async updateName (name: string) {
    if (this.file.id) {
      const infoSettings: Json = {}
      infoSettings[`files:${this.file.id}:name`] = name
      await this.item.data?.save({ infoSettings })
    } else {
      this.file.name = name
      await this.create()
    }
  }

  async updateHide (hide: boolean) {
    this.file.hide = hide
    if (this.file.id) {
      const infoSettings: Json = {}
      infoSettings[`files:${this.file.id}:hide`] = hide
      await this.item.data?.save({ infoSettings })
    } else {
      await this.create()
    }
  }

  async create () {
    const infoSettings: Json = {}
    this.file.sort = arrayCrdtSortNumber(this.files)
    this.file.id = new Date().getTime().toString()
    infoSettings[`files:${this.file.id}:id`] = this.file.id
    infoSettings[`files:${this.file.id}:sort`] = this.file.sort
    infoSettings[`files:${this.file.id}:url`] = this.file.url
    infoSettings[`files:${this.file.id}:name`] = this.file.name
    infoSettings[`files:${this.file.id}:hide`] = this.file.hide
    await this.item.data?.save({ infoSettings })
  }
}
